// PawandLuna mobile menu drawer branding footer
(function () {
  "use strict";

  var LOGO_URL = "https://cdn.shopify.com/s/files/1/1023/5042/2304/files/pawluna-drawer-icon.png?v=1792198661&width=160";

  var CSS = "\
.plb-drawer-brand{margin-top:20px;padding:24px 20px;display:flex;flex-direction:column;gap:14px;background:linear-gradient(165deg,#FAF5EC 0%,#F3EADA 100%);border-radius:16px}\
.plb-drawer-brand-top{display:flex;align-items:center;gap:12px}\
.plb-drawer-brand-logo-img{width:40px;height:40px;object-fit:contain;flex-shrink:0}\
.plb-drawer-brand-text{display:flex;flex-direction:column;gap:1px}\
.plb-drawer-brand-name{font-family:inherit;font-size:1.05rem;font-weight:700;letter-spacing:.02em;color:#2b2318;line-height:1.2}\
.plb-drawer-brand-sub{font-size:.68rem;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#B08D57;line-height:1.2}\
.plb-drawer-brand-tag{font-size:.8rem;opacity:.7;line-height:1.5;color:#2b2318}\
.plb-drawer-brand-perks{display:flex;gap:14px;flex-wrap:wrap;padding-top:4px;border-top:1px solid rgba(176,141,87,.2)}\
.plb-drawer-brand-perk{display:flex;align-items:center;gap:5px;font-size:.72rem;font-weight:600;color:#6b5a3f}\
.plb-drawer-brand-perk svg{width:14px;height:14px;flex-shrink:0;color:#B08D57}\
";

  function buildBrandBlock() {
    var wrap = document.createElement("div");
    wrap.className = "plb-drawer-brand";
    wrap.innerHTML =
      '<div class="plb-drawer-brand-top">' +
        '<img class="plb-drawer-brand-logo-img" src="' + LOGO_URL + '" alt="PawandLuna" loading="lazy">' +
        '<div class="plb-drawer-brand-text">' +
          '<span class="plb-drawer-brand-name">PawandLuna</span>' +
          '<span class="plb-drawer-brand-sub">Made for cats who run the house</span>' +
        '</div>' +
      '</div>' +
      '<div class="plb-drawer-brand-perks">' +
        '<span class="plb-drawer-brand-perk"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>Free US Shipping</span>' +
        '<span class="plb-drawer-brand-perk"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>30-Day Returns</span>' +
      '</div>';
    return wrap;
  }

  function injectBrand() {
    if (document.querySelector(".plb-drawer-brand")) return;
    var candidates = document.querySelectorAll('nav, [class*="menu-drawer"], [class*="MenuDrawer"], dialog');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var links = el.querySelectorAll('a');
      var hasContact = Array.prototype.some.call(links, function (a) {
        return /contact/i.test(a.textContent || "");
      });
      if (hasContact) {
        var list = el.querySelector('ul, [role="list"]') || el;
        list.parentElement.appendChild(buildBrandBlock());
        return;
      }
    }
  }

  var style = document.createElement("style");
  style.textContent = CSS;
  document.head.appendChild(style);

  var observer = new MutationObserver(injectBrand);
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener("click", function () { setTimeout(injectBrand, 150); });
  injectBrand();
})();
